export class LogSunat {
    public id: number;
    public logCustRequest: any;
    public lastSendDate: string;
    public signatureDate: string;
    public sunatResponses: any[];
    public respuestaString: string;
    public retryCount: number;
    public seleccionado: boolean;
    public linkRequestPSE: string;
    public linkRequestXML: string;
    public linkResponseCDR: string;
    public linkResponsePDF: string;
    public fileName: string;
    public fechaEmisionCPE: string;
    public respuesta: any;
    public requestDate: string;


    constructor(id: number = null,
                logCustRequest: any = null,
                respuestaString: string = "",
                retryCount: number = 0,
                sunatResponses: any[] = null,
                signatureDate: string = "",
                lastSendDate: string = "") {

        this.id = id;
        this.logCustRequest = logCustRequest;
        this.respuestaString = respuestaString;
        this.retryCount = retryCount;
        this.sunatResponses = sunatResponses;
        this.signatureDate = signatureDate;
        this.lastSendDate = lastSendDate;
        this.seleccionado = false;
        this.linkRequestPSE = "";
        this.linkRequestXML = "";
        this.linkResponseCDR = "";
        this.linkResponsePDF = "";
    }
}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/transaccion/logSunat/recursos/modelo/LogSunat.ts